import AssignmentIcon from '@mui/icons-material/Assignment';
import FolderIcon from '@mui/icons-material/Folder';
import { Badge, Box, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import useTaskSummary, { seesTasks } from './useTaskSummary';

/**
 * Files / Tasks links in the header. Only shown to PMs, task viewers, AV team and people who
 * are on at least one task; everyone else sees no change.
 */
const HeaderTasksLink = ({ inVideoEditor = false }) => {
    const summary = useTaskSummary();
    const navigate = useNavigate();
    const location = useLocation();
    if (!seesTasks(summary) || inVideoEditor) {
        return null;
    }
    const onTasks = location.pathname.startsWith('/tasks');
    const linkSx = (active) => ({
        textTransform: 'none',
        fontWeight: active ? 600 : 400,
        borderBottom: '2px solid',
        borderColor: active ? 'primary.main' : 'transparent',
        borderRadius: 0,
        color: 'inherit',
    });
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mr: 2 }} className="header-task-links">
            {!summary.avOnly && (
                <Button size="small" startIcon={<FolderIcon />} sx={linkSx(!onTasks)} onClick={() => navigate('/')}>
                    Files
                </Button>
            )}
            <Button
                size="small"
                startIcon={
                    <Badge badgeContent={summary.openCount || 0} color="primary" max={99}>
                        <AssignmentIcon />
                    </Badge>
                }
                sx={linkSx(onTasks)}
                onClick={() => navigate('/tasks')}
                aria-label={`Tasks, ${summary.openCount || 0} assigned to you`}
            >
                Tasks
            </Button>
        </Box>
    );
};

export default HeaderTasksLink;
